module.exports = __webpack_public_path__ + "media/images/branden-grace.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/branden-grace.jpg
// module id = 63
// module chunks = 0